import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { formatStorePrice } from '../../../utils/ecommerce/currency';

function FlyoutPriceChanges(props) {
	let formUpdate = props.bundleUpdates;

	if (Array.isArray(formUpdate)) {
		return (
			<div className="flyout__status">
				<p className="font-size-0">Cart changes: $0</p>
			</div>
		);
	}
	let amount = Math.abs(formUpdate.total);
	let operationSymbol = amount == 0 ? '' : formUpdate.operationSymbol;

	let total = formatPrice(amount, formUpdate.currency, formUpdate.formattedLocale);

	return (
		<div className="flyout__status">
			<p className="font-size-0">{`Cart changes: ${operationSymbol}${total}`}</p>
		</div>
	);
}

function formatPrice(price, currency, formattedLocale) {
	const isWholeNumber = price % 1 === 0;
	const currencyOptions = isWholeNumber ? { maximumFractionDigits: 0 } : undefined;
	return formatStorePrice(price, formattedLocale, currency, currencyOptions);
}

function mapStateToProps({ bundleUpdates }) {
	return {
		bundleUpdates,
	};
}

export default connect(mapStateToProps, actions)(FlyoutPriceChanges);
